<!-- =========================================================================================
    File Name: PartnerJoin.vue
    Description: Связывание устройств c партнером
========================================================================================== -->


<template>
    <vs-prompt
        title="Связывание устройств c партнером"
        accept-text= "Связать"
        cancel-text = "Закрыть"
        button-cancel = "border"
        @accept="submitAction"
        :is-valid="validateForm"
        :active.sync="activePrompt">
        <div>
            <form>

                <div class="vx-row">
                    <div class="vx-col w-full">
                        <p>Выберите партнера, с которым нужно связать устройства.</p>
                        <vs-select v-model="partnerId" label="Партнер" class="pb-4 w-150">
                            <vs-select-item class="w-150" :key="item.partid" :value="item.partid" :text="item.company" v-for="item in partnerList" />
                        </vs-select>
                        <vs-textarea rows="5" label="Описание" v-model="description" />
                    </div>
                </div>

            </form>
        </div>
    </vs-prompt>
</template>

<script>
import modulePartner          from '@/store/partner/modulePartner.js'

export default {
    props: {
        displayPrompt: {
            type: Boolean,
            required: true,
        },
        devices: {
            type: Array,
            required: true,
        }
    },
    data() {
        return {
            partnerId: 0,
            description: '',
        }
    },
    computed: {
        partnerList() {
            return this.$store.state.partner.partners
        },
        activePrompt: {
            get() {
                return this.displayPrompt
            },
            set(value) {
                this.$emit('hidePromptJoin', value)
            }
        },
        validateForm() {
            return !this.errors.any() && this.partnerId !== 0
        }
    },
    methods: {
        submitAction() {
            this.$store.dispatch("partner/createDevice", {devices: this.devices, partid: this.partnerId, descr: this.description})
        }

    },
    created() {
        if (!modulePartner.isRegistered) {
            this.$store.registerModule('partner', modulePartner)
            modulePartner.isRegistered = true
        }

        this.$store.dispatch("partner/fetchPartners")
    }
}
</script>

<style lang="scss">

    .con-select {
        width: 350px;
    }

</style>